import { Icon, LegacyCard, Text } from "@shopify/polaris"
import { Observer } from "mobx-react"
import { observer } from "mobx-react"
import { ChevronRightIcon } from "polaris-enhance"
import { Fragment } from "react"
import { useHistory } from "react-router"

import stores from "@/stores"

import ReviewSkeleton from "./ReviewSkeleton"

const ReviewCard = () => {
  const history = useHistory()

  const { ReturnRequestsDataStore, ManagementStore, CommonStore } = stores

  const buildState = (extra: Record<string, string>) => ({
    ...extra,
    request_date: CommonStore.selectDateTime.dashboard.day,
    request_date_start: CommonStore.selectDateTime.dashboard.subscribed_at_min,
    request_date_end: CommonStore.selectDateTime.dashboard.subscribed_at_max,
  })

  return (
    <Observer>
      {() => {
        const loading = ReturnRequestsDataStore.loading.dashboardLoading
        const renderConfig = [
          {
            title: t("PendingReview0"),
            desc: t("WaitingForYourReview"),
            count: ReturnRequestsDataStore.pending_review_count,
            onAction: () => {
              ManagementStore.setTabSelectedIndex(1)
              history.push(
                "/return-management",
                buildState({ request_status: "1" }),
              )
            },
          },
          {
            title: t("PendingRefund0"),
            desc: t("ApprovedWaitingForRefund"),
            count: ReturnRequestsDataStore.pending_refund_count,
            onAction: () => {
              ManagementStore.setTabSelectedIndex(0)
              history.push(
                "/return-management",
                buildState({ resolution_status: "2", request_status: "2" }),
              )
            },
          },
          {
            title: t("PendingExchange"),
            desc: t("ApprovedWaitingForExchange"),
            count: ReturnRequestsDataStore.pending_create_exchange_order_count,
            onAction: () => {
              ManagementStore.setTabSelectedIndex(0)
              history.push(
                "/return-management",
                buildState({ resolution_status: "3", request_status: "2" }),
              )
            },
          },
        ]
        const visibleConfig = renderConfig
        const showReviewCard = visibleConfig.length > 0

        if (loading) {
          return <ReviewSkeleton />
        }

        if (!showReviewCard) {
          return null
        }

        return (
          <LegacyCard>
            <div className="flex flex-col items-stretch p-2 gap-2 sm:flex-row">
              {visibleConfig.map((item, index) => (
                <Fragment key={item.title}>
                  {index > 0 && (
                    <div className="h-px w-full self-center bg-[#e3e3e3] sm:h-11 sm:w-px" />
                  )}
                  <div
                    className="group flex flex-1 cursor-pointer items-center gap-4 rounded-lg p-2 hover:bg-[#f7f7f7] active:bg-[#f1f1f1]"
                    onClick={item.onAction}
                  >
                    <span className="inline-flex min-w-8 items-center justify-center rounded-lg bg-black/[0.06] px-2 py-1">
                      <Text variant="headingSm" as="span" tone="subdued">
                        {item.count}
                      </Text>
                    </span>
                    <div className="min-w-0 flex-1">
                      <Text variant="bodyMd" as="p" fontWeight="semibold">
                        {item.title}
                      </Text>
                      <Text variant="bodyMd" as="p" tone="subdued">
                        {item.desc}
                      </Text>
                    </div>
                    <span className="opacity-100 transition-opacity sm:opacity-0 sm:group-hover:opacity-100">
                      <Icon source={ChevronRightIcon} tone="subdued" />
                    </span>
                  </div>
                </Fragment>
              ))}
            </div>
          </LegacyCard>
        )
      }}
    </Observer>
  )
}

export default observer(ReviewCard)
